<template>
  <div class="index_news">
    <div class="news_main" v-infinite-scroll="loadMore">
      <el-row
        style="margin:0 0 1vh 10%;width:90%;"
        v-for="(item,index) in news"
        :key="item.id">
        <el-col :span="24">
          <el-row v-if="index===0 || item.dates !== news[index-1].dates">
            <el-col>
              <el-link type="primary" style="font-size:1.1rem;"><el-icon class="el-icon-time"></el-icon> {{item.dates}}</el-link>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-card>
                <div class="news_title" @click="getDetail(item.id)">
                  {{item.title}}
                </div>
                <div class="news_category">
                <span :class="`news_cate `+cateTypes[ct]" v-for="(ct,index) in item.cates" :key="ct" v-if="index<4">
                  {{ct}}
                </span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
      <el-dialog
        :visible.sync="newsDialogVisible"
        :fullscreen="true"
        @close="closeDetail">
        <div class="news_detail_title">
          {{detail.title}}
        </div>
        <div class="news_detail_head">
          {{detail.froms || '新闻来源：'+detail.type}} 日期：{{detail.dates}}
        </div>
        <div class="news_detail_cate">
        <span :class="`news_cate `+cateTypes[cat]" v-for="cat in detail.cates" :key="cat">
          {{cat}}
        </span>
        </div>
        <div class="news_detail_content" v-html="detail.content">
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="newsDialogVisible = false">返 回 列 表</el-button>
      </span>
      </el-dialog>
  </div>
</template>

<script>
  import {getNewsList, getNewsDetail} from '../../api/api'

  export default {
    name: "IndexNews",
    data() {
      return {
        id: this.$route.query.id,
        page: 1,
        size: 10,
        loading: false,
        news: [],
        detail: {},
        newsDialogVisible: false,
        cateTypes: {
          '公告': 'news_cate_1',
          '货物运输': 'news_cate_2',
          '船舶交易': 'news_cate_3',
          '船舶建造': 'news_cate_4',
          '航运贸易': 'news_cate_5',
          '集装箱相关': 'news_cate_6',
          '互保协会': 'news_cate_7',
          '船东动态': 'news_cate_8',
          '其他': 'news_cate_99'
        }
      }
    },
    mounted() {
      window.addEventListener('popstate',()=>{
        if(this.newsDialogVisible){
          this.closeDetail();
          this.newsDialogVisible = false;
        }
      },false);
      if (this.id && this.id > 0) {
        this.getDetail(this.id);
      }
    },
    methods: {
      loadMore() {
        if (!this.loading) {
          this.loading = true;
          getNewsList(this.page, this.size).then(res => {
            if (res && res.status === 0 && res.data) {
              for (let d in res.data) {
                res.data[d]['cates'] = res.data[d]['cate'].split(",");
                this.news.push(res.data[d]);
              }
              this.page++;
            }
            this.loading = false;
          });
        }
      },
      getDetail(id) {
        getNewsDetail(id).then(res => {
          if (res && res.status === 0) {
            this.newsDialogVisible = true;
            res.data['cates'] = res.data['cate'].split(',');
            this.detail = res.data;
            if (!this.id || this.id !== id) this.$router.push('/index/news?id=' + id)
          }
        })
      },
      closeDetail(){
        this.$router.push('/index/news')
      }
    }
  }
</script>

<style scoped>
  .index_news {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #eee;
    overflow-y: scroll;
  }

  .news_head {
    margin: 0;
    width: 100%;
    text-align: center;
    height: 3vh;
    line-height: 5vh;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .news_main {
    width: 92%;
    margin: 3vh 8% 6vh 0;
  }

  .news_title {
    width: 100%;
    font-size: .8rem;
  }

  .news_detail_title {
    font-size: 1rem;
    font-weight: bold;
  }

  .news_detail_head {
    font-size: .75rem;
    color: grey;
    height: 1.6rem;
    margin: .5rem 0 .5rem 0;
    border-bottom: 1px dashed #ccc;
  }

  .news_detail_cate {
    height: 1.6rem;
    margin: .5rem 0 .5rem 0;
    border-bottom: 1px dashed #ccc;
  }

  .news_detail_content {
    line-height: 1.5rem;
    letter-spacing: .1rem;
    font-size: .9rem;
  }

  .news_category {
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    margin-top: .5rem;
  }

  .news_cate {
    display: inline-block;
    height: 1rem;
    line-height: 1rem;
    width: 3rem;
    text-align: center;
    font-size: .6rem;
    border: 1px solid grey;
    color: grey;
    border-radius: .3rem;
    float: left;
    margin: 0 .5rem 0 0;
  }

  .news_cate_1 {
    color: rgb(54, 98, 236);
    border-color: rgb(54, 98, 236);
  }

  .news_cate_2 {
    color: rgb(250, 81, 81);
    border-color: rgb(250, 81, 81);
  }

  .news_cate_3 {
    color: rgb(222, 159, 49);
    border-color: rgb(222, 159, 49);
  }

  .news_cate_4 {
    color: rgb(172, 172, 32);
    border-color: rgb(172, 172, 32);
  }

  .news_cate_5 {
    color: rgb(0, 162, 233);
    border-color: rgb(0, 162, 233);
  }

  .news_cate_6 {
    color: rgb(0, 182, 182);
    border-color: rgb(0, 182, 182);
  }

  .news_cate_7 {
    color: rgb(183, 0, 120);
    border-color: rgb(213, 50, 150);
  }

  .news_cate_8 {
    color: rgb(14, 183, 0);
    border-color: rgb(14, 183, 0);
  }

  .news_cate_99 {
    color: #aaa;
    border-color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/news.vue